import React from "react";
import {connect} from 'react-redux'
import {Link} from "react-router-dom";
import moment from 'moment'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import StoreMallDirectory from "@material-ui/icons/StoreMallDirectory";
//import GridContainer from "components/Grid/GridContainer.jsx";
//import GridItem from "components/Grid/GridItem.jsx";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckIcon from "@material-ui/icons/CheckCircle";
import IconButton from '@material-ui/core/IconButton';

import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import {
  danger,
} from 'actions/notification';

import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";
import Datetime from "react-datetime";

//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";

import {formatToSelectValues} from 'views/utils/helpers'
// Actions
import {
  transactionFilter,
  transactionsFetch,
  transactionRemove,
  setTransactionViewFilter,
  approveTransaction,
  declineTransaction
} from 'actions/transactions'

import {
  transactionDestination,
  transactionStatus
} from 'enums'

import {
  ibsFetchAll,
  ibFilter
} from 'actions/ibs'

import {
  userFetch
} from 'actions/users'
//import Button from "components/CustomButtons/Button.jsx";

class List extends React.Component {
  selected=[]
  state = {
    ibList: [],
    remoteFilters:{
      ibId: '',
      destination: '',
      status: '',
      changeStatusTime: ''
    },
    selected: [],
    statusSelect: [{value:'APPROVED', name:'APPROVED'},{value:'REQUESTED_WITHDRAWAL', name:'REQUESTED APPROVAL'},{value:'DECLINED', name:'DECLINED'}],
    ibId: 0,
    status: '',
    from: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(8,'day').format(),
    to: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format(),
    destination: ''
  }
  componentDidMount(){
    
    //this.filter({sort:{withdrawalId: 'asc'}, size:10});

    /*let fromFormat = moment(new Date()).subtract(7,'day').startOf('day').format()
    let toFormat = moment(new Date()).startOf('day').format()*/
    
    let fromFormat = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(8,'day').format()
    let toFormat = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(0,'day').format()
    
    //let fromFormat = moment(`${moment(new Date()).tz("America/New_York").format('YYYY-MM-DD')} 17:00`).subtract(7,'day').format();
    //let toFormat = moment(`${moment(new Date()).tz("America/New_York").format('YYYY-MM-DD')} 17:00`).format();

    this.props.fetch(this.state.ibId,Date.parse(fromFormat),Date.parse(toFormat),this.state.destination,this.state.status);
    
    this.props.userFetch();
    this.props.ibFilter({size: 1000000,sort:{firstName: 'asc'}})
    this.props.ibsFetchAll().then(e=>{

          this.setState({
          ...this.state,
          ibList:e,
        })

    }); 
   
  }

  //on choose record
  select(id) {
    let select = []
    if (Array.isArray(id)) 
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1) 
      select = this.state.selected.filter((e) => e !== id)
    else 
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
  }
  confirmDelete() {
      if(this.selected.length===0){
        this.props.fetch();
        this.setState({
          ...this.state,
          selected:[],
          alert: <SuccessAlert
            title={`Done!`}
            onConfirm={()=>{this.setState({...this.state,alert:false});}}
          />
        });
        return false;
      }
      this.setState({
        ...this.state,
        alert: <ProgressAlert
        value={100-((this.selected.length*100)/this.state.selected.length)}
        title={`Delete Transactions (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
        />
      });
      this.props.remove(this.selected[0])
        .then((e)=>{
          this.selected=this.selected.slice(1);
          this.confirmDelete();
        }).catch((e) => {
        this.props.danger(e+'',4)
        this.setState({...this.state,alert:false})
      })
  }
  //on choose click delete 
  delete() {
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} transactions \n( ${
          this.state.selected.map(id=>this.props.transactions.list.find(e=>e.withdrawalId===id).name).join(', ')
        } )`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
      }}
      />
    });
  }
  //Filter change for pagination or limitation
  filter(filter){
    this.setState({...this.state,selected:[]})
    this.props.filter({
      ...this.props.transactions.pageable,
      ...filter,
      page: filter.size 
        ? 0 
        : filter.page !== undefined ? filter.page : this.props.transactions.pageable.page
    })
    this.props.fetch()
  }
  approveTransaction(id) {
    this.props.approveTransaction(id)
    window.location.reload();
  }
  declineTransaction(id) {
    this.props.declineTransaction(id)
    window.location.reload();
  }
  // getTableTitle() {
  //   const {match, classes} = this.props;
  //   return  <GridContainer>
  //     <GridItem>
  //       <Link to={`${match.path}/create-withdrawal`}>
  //         <Button className={classes.submit} color='warning'>Create Withdrawal</Button>
  //       </Link>
  //     </GridItem>
  //   </GridContainer>
    
  // }
  getIbsName(ibId,ibs){

    let ibName = '';

    ibs.forEach(i => {
      if  (i.ibId===ibId) {
        ibName =  i.name+' '+i.lastName+' ('+i.ibId+')';
      }
    })

    return ibName;
     
  }
  getUserName(userId,users) {

    let userName = '';

    if (!this.props.users.isFetching) {
    
      Object.keys(users.list).forEach(key => {
    
        if (users.list[key].userId === userId) {
          userName = users.list[key].name+' ( '+users.list[key].userId+' )';
        }
    
      })
       
    }


  return userName;
   
}

handleChange(e, filter){
    let state = this.state
    let value = filter === 'from' || filter === 'to' ? e : e.target.value
    
    //this.setState({[filter]: value},() => this.fetchReport())

    state[filter] = value
    this.setState({...state},() => this.fetchReport())
    
  }
  fetchReport(){
    const{from, to, ibId, destination, status} = this.state
    
    //let fromFormat = moment.utc(from).format()
    //let toFormat = moment.utc(to).endOf('day').format()

    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();
    

    this.props.fetch(ibId,Date.parse(fromFormat),Date.parse(toFormat),destination,status);
  }

renderFilters(){
    const {classes,ibs} = this.props
    const {ibId,destination,statusSelect,status,ibList} = this.state
    
    const fromDate = this.state.from
      ? moment(this.state.from).startOf('day').format('YYYY-MM-DD')
      : ''

    const toDate = this.state.to
      ? moment(this.state.to).endOf('day').format('YYYY-MM-DD')
      : ''

    const destinations = formatToSelectValues(transactionDestination);
    // const tomorrow = moment.utc(new Date()).add(1,'days').endOf('day')
    // const valid = (current) => {
    //   return current.isBefore(tomorrow)
    // }
    
    return (
      <GridContainer style={{marginBottom: '30px'}}>
        <GridItem xs={3}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="ibId" className={classes.selectLabel}>
              IB
            </InputLabel>
            <Select
              value={ibId}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "ibId"),
                id: "ibId",
                name: "ibId"
              }}>
              <MenuItem
              key={0}
              classes={{
                root: classes.selectMenuItem
              }}
              value={0}>
              {'All'}
            </MenuItem>
            { ibList.length && 
                ibList.map((e) => (
                  <MenuItem
                    key={e.ibId}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e.ibId}>
                    {e.name+' '+e.lastName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          
        </GridItem>
      <GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="status" className={classes.selectLabel}>
              Status
            </InputLabel>
            <Select
              value={status}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "status"),
                id: "status",
                name: "status"
              }}>
              <MenuItem
              key={0}
              classes={{
                root: classes.selectMenuItem
              }}
              value={null}>
              {'All'}
            </MenuItem>
              {statusSelect
                .map((e) => (
                  <MenuItem
                    key={e.value}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e.value}>
                    {e.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          
        </GridItem>
        <GridItem xs={2}>
            
            <FormControl className={classes.selectFormControl} style={{paddingTop: '13px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel} style={{marginTop: '-25px'}}>Date Created: <strong>From</strong></InputLabel>
            
              <Datetime
                id="from"
                name="from"
                props={{
                  name:"from"
                }}
                dateFormat={'YYYY-MM-DD'}
                timeFormat={false}
                inputProps={{
                  id:"from",
                  name:"from",
                  readOnly:true,
                  placeholder: 'yyyy/mm/dd'
                }}
                onChange={(event) => this.handleChange(event, "from")}
                utc={true}
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                value={fromDate}
                className={classes.select + ' ' + classes.datepickerText}
              />
            </FormControl>
        </GridItem>

        <GridItem xs={2}>
          <FormControl className={classes.selectFormControl} style={{paddingTop: '13px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel} style={{marginTop: '-25px'}}>Date Created: <strong>To</strong></InputLabel>
              <Datetime
                id="from"
                name="to"
                props={{
                  name:"to"
                }}
                dateFormat={'YYYY-MM-DD'}
                timeFormat={false}
                inputProps={{
                  id:"to",
                  name:"to",
                  readOnly:true,
                  placeholder: 'yyyy/mm/dd'
                }}
                onChange={(event) => this.handleChange(event, "to")}
                utc={true}
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                value={toDate}
                className={classes.select + ' ' + classes.datepickerText}
              />

          </FormControl>
        </GridItem>
        <GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="ibId" className={classes.selectLabel}>
              Destination
            </InputLabel>
              
              <Select
              value={destination}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "destination"),
                id: "destination",
                name: "destination"
              }}>
              <MenuItem
              key={0}
              classes={{
                root: classes.selectMenuItem
              }}
              value={0}>
              {'All'}
            </MenuItem>
              {destinations
                .map((e) => (
                  <MenuItem
                    key={e.value}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e.value}>
                    {e.label}
                  </MenuItem>
                ))}
            </Select>

          </FormControl>
        </GridItem>
        
        
        
      </GridContainer>
    )
  }

  

  render() {
    const {transactions, match, ibs, users} = this.props;
    const { selected,ibList } = this.state;
    const  ACTIONELEMENTS = ['APPROVED', 'DECLINED'];
    return (
      <Card>
        {this.state.alert}
        {
        (!transactions.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={transactions.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={transactions.pageable.totalPages>1?{
            pages:transactions.pageable.totalPages,
            current:transactions.pageable.page+1,
          }:false}
          // title={this.getTableTitle()}
          dark={selected.length>0}
          icon={<StoreMallDirectory/>}
          actions={{
            add: (selected.length===0)
            ? <Link to={`${match.path}/add`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && this.props.permissions.includes('WITHDRAWALS_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? ''
              // <Link to={`${match.path}/${this.state.selected[0]}`}>
              //     <IconButton>
              //         <EditIcon/>
              //     </IconButton>
              //   </Link>
              : ''
        }}/>:''}

        <CardBody>
        {this.renderFilters()}
          {/* If is fetching not display table*/}
          {(transactions.isFetching)
            ? <LinearProgress color="primary"/>
            : (
              //Main table
              <Table
                tableHeaderColor="primary"
                sort={transactions.pageable.sort}
                onSort={(e)=>this.filter({sort:{[e]:transactions.pageable.sort[e]==='desc'?'asc':'desc'}}) }
                tableHead={{ 
                    checkbox:<Checkbox props = {{ 
                      onClick:()=>this.select(transactions.list.map(e=>e.withdrawalId)),
                      checked:this.state.selected.length===transactions.list.length}
                    }/>,
                    withdrawalId:"#", 
                    ibId: "IB", 
                    amount: "Amount", 
                    destination: "Destination",
                    approvingUserId:"Approving Operator",
                    changeStatusTime: "Change Status Time",
                    creatingUserId: "Created By",
                    creationTime: "Date Created",
                    status: "Status",
                    actions: ''
                  }}
                tableData={transactions.list.map((e,i) => [
                  !ACTIONELEMENTS.includes(e.status) &&
                    <Checkbox props = {{ onClick:()=>this.select(e.withdrawalId), checked:this.state.selected.indexOf(e.withdrawalId)>-1 }}/>,
                    e.withdrawalId, 
                    this.getIbsName(e.ibId,ibList), 
                    e.amount, 
                    transactionDestination[e.destination].label, 
                    this.getUserName(e.approvingUserId,users),
                    moment(e.changeStatusTime).format('YYYY-MM-DD HH:mm:ss'),
                    this.getUserName(e.creatingUserId,users),
                    moment(e.creationTime).format('YYYY-MM-DD HH:mm:ss'),
                    transactionStatus[e.status].label,((e.status==='REQUESTED_WITHDRAWAL')?
                    <div>
                      <IconButton onClick={ev => this.approveTransaction(e.withdrawalId)} style={{color: '#4caf50'}}>
                        <CheckIcon/>
                      </IconButton>
                      <IconButton onClick={ev => this.declineTransaction(e.withdrawalId)} style={{color: '#f44336'}}>
                        <CancelIcon/>
                      </IconButton>
                    </div>:'')
                  ] )}/>
            )}
        </CardBody>
       { 
         transactions.list.length>20
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={transactions.pageable.totalPages>1?{
              pages:transactions.pageable.totalPages,
              current:transactions.pageable.page+1,
            }:false}
        />:''}
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  transactions: state.transactions,
  ibs: state.ibs.list,
  users: state.users,
  permissions: state.auth.permissions
})
const mapDispatchToProps = (dispatch) => ({
  filter: (filter) => dispatch(transactionFilter(filter)),
  fetch: (ibId,from,to,destination,filter,loading) => dispatch(transactionsFetch(ibId,from,to,destination,filter,loading)),
  remove: (id) => dispatch(transactionRemove(id)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  setTransactionViewFilter: (data) => dispatch(setTransactionViewFilter(data)),
  approveTransaction: (id) => dispatch(approveTransaction(id)),
  declineTransaction: (id) => dispatch(declineTransaction(id)),
  ibsFetchAll: () => dispatch(ibsFetchAll()),
  ibFilter: (filter) => dispatch(ibFilter(filter)), 
  userFetch: (filter) => dispatch(userFetch(filter)),
})
export default withStyles(buttonsStyle)(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/Transactions/List.jsx